import {SchedulesService} from "./service/SchedulesService";
import {SchedulingServiceModule} from "./SchedulingServiceModuleConfiguration";
import {QueuedTaskService} from "./service/QueuedTaskService";
import {QueuedTaskServiceName} from "../utils/names/serviceNames";

SchedulingServiceModule
    .createNewModule()
    .service('SchedulesService', ['$http', SchedulesService])
    .service(QueuedTaskServiceName, QueuedTaskService.instance);